import { createApp } from 'vue';
import App from './App.vue';
import i18n from './localization/i18n';
import router from './routes/router';
import globalStyles from './styles.module.css';

// Patternlib
import { PatternLibraryPlugin } from '@liebherr/patternlib-vue';
if (import.meta.env.MODE == 'development') { // patternlib styles are only imported at local dev mode, in production the surrounding site will deliver them
  import('@liebherr/patternlib/dist/patternlib/patternlib.css')
  import('@liebherr/patternlib/www/assets/css/patternlib-fonts.css')
}


//Pinia
import { createPinia } from 'pinia';
const pinia = createPinia();

const app = createApp(App)
  .use(i18n)
  .use(PatternLibraryPlugin)
  .use(router)
  .use(pinia);

app.config.globalProperties.$gStyle = (str: string) => {
  let scopedStr = '';
  for (let cssClass of str.split(' ')) {
    // import via 'import mainStyles from './main.modules.css' does not return all classes in production so generate function is needed here also
    scopedStr += globalStyles[cssClass]
      ? globalStyles[cssClass] + ' '
      : 'itde:' + cssClass + ' ';
  }
  return scopedStr;
};

//Force tailwind to be rerun on hot reload
if (import.meta.env.MODE === 'development' && import.meta.hot) {
  //re-evaluate this module <=> rerun imported files
  import.meta.hot.accept(() => {});
}

app.mount('#scip_app');
